import React from "react";

export default function CheckWithDateMobile(props) {
  return (
    <div
      className="container-check-with-name"
      title={`Revoked by: ${props.title}`}
      style={{ cursor: "pointer" }}
    >
      {/* {props.checked == true ? (
        <img
          style={{
            width: "24px",
            height: "24px",
          }}
          src={CheckGreen}
        />
      ) : props.checked == false ? (
        <img
          style={{
            width: "24px",
            height: "24px",
          }}
          src={CancelIcon}
        />
      ) : (
        <img
          style={{
            width: "24px",
            height: "24px",
          }}
          src={incomingIcon}
        />
      )} */}

      <div className="name-for-check-mobile">{props.content} </div>
    </div>
  );
}
